import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card, Typography, Row, Col, Switch, message, Spin } from 'antd';
import Alert from 'components/Alert';
import merchantAPI from 'services/merchants';

const SettingsCardWrapper = styled(Card)`
  border-radius: 12px;
  margin: 0px 15px 15px 0px;
`;

const PageWrapper = styled.div`
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Notifications({ userinfo }) {
  const merchantId = userinfo?.merchant_id;
  const [emailToggle, setEmailToggle] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const editableNotification = userinfo?.configuration?.permission_configs?.can_edit_notifications;

  const fetchNotificationConfig = async () => {
    try {
      const response = await merchantAPI.fetchNotificationConfig();
      if (response.success) {
        setEmailToggle(response?.data?.notification_config?.can_notify_on_kyc_approved);
      }
    } catch (error) {
      Alert('Something went wrong', 'Please contact support team for this.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificationConfig();
  }, [merchantId]);

  const handleToggle = async (checked) => {
    setLoading(true);
    try {
      const response = await merchantAPI.updateOnboardingNotification({
        can_notify_on_kyc_approved: checked
      });

      if (response.success) {
        setEmailToggle(checked);
        message.success('Notification preference updated successfully');
      } else {
        message.error('Failed to update notification preference');
      }
    } catch (error) {
      Alert('Something went wrong', 'Please contact support team for this.', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return (
      <PageWrapper>
        <Spin size="large" tip="Loading notification settings..." />
      </PageWrapper>
    );
  }

  return (
    <SettingsCardWrapper>
      <Row>
        <Col style={{ marginTop: 0 }}>
          <Typography.Title level={5} style={{ marginBottom: 24 }}>
            Notify on Referral KYC Approval
          </Typography.Title>
        </Col>
      </Row>
      <Row align="middle">
        <Col>
          <Typography.Text strong>Email</Typography.Text>
          <br />
          <Typography.Text type="secondary">
            Notifies you by email each time a referral&apos;s KYC is approved.
          </Typography.Text>
        </Col>
        <Col>
          <Switch
            checked={emailToggle}
            style={{ marginLeft: 100 }}
            onChange={handleToggle}
            loading={loading}
            disabled={!editableNotification}
          />
        </Col>
      </Row>
    </SettingsCardWrapper>
  );
}

Notifications.propTypes = {
  userinfo: PropTypes.instanceOf(Object).isRequired
};

export default Notifications;
